// Orenza kbd chip — for showing Tally / modern shortcuts in UI.
// e.g. <KbdChip>F8</KbdChip>, <KbdChip>Ctrl K</KbdChip>

import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface KbdChipProps {
  children: ReactNode;
  size?: 'sm' | 'md';
  className?: string;
}

export function KbdChip({ children, size = 'sm', className }: KbdChipProps) {
  return (
    <kbd
      className={cn(
        'inline-flex items-center justify-center whitespace-nowrap font-mono text-slate bg-frost border border-mist rounded-sm',
        size === 'sm' ? 'h-5 min-w-[20px] px-1.5 text-micro' : 'h-6 min-w-[24px] px-2 text-caption',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
